import * as types from '../actions/ActionTypes';

/** The initial state; no tokens and no user info */
const initialState = {
  accessToken: null,
  refreshToken: null,
  user: {
    loading: false,
    country: null,
    display_name: null,
    email: null,
    external_urls: {},
    followers: {},
    href: null,
    id: null,
    images: [],
    product: null,
    type: null,
    uri: null,
  }
};

const LOCAL_STORAGE_USER_KEY = 'spotify-user-auth-info';

const setCurrentUser = (currentUser) => {
  localStorage.setItem(LOCAL_STORAGE_USER_KEY, JSON.stringify(currentUser));
};

export const getCurrentUser = () => {
  try {
    let user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_KEY));
    let accessToken = localStorage.getItem('access_token');
    let refreshToken = localStorage.getItem('refresh_token');

    return {user: user, accessToken: accessToken, refreshToken: refreshToken};

  } catch(e) {
    return undefined;
  }
};


const currentUser = (state = initialState, action) => {
  switch(action.type) {
    
    case types.GET_CURRENT_USER:
      let detail = getCurrentUser();
      return Object.assign({}, state, detail, {loading: false});
    
    case "USER_LOGOUT":
      return null;

    case types.SPOTIFY_TOKENS_BEGIN: 
      console.log('getting tokens');
      return state;
    
    case "SPOTIFY_TOKENS":
      const {accessToken, refreshToken} = action;
      return Object.assign({}, state, {accessToken, refreshToken});
    
    case "SPOTIFY_ME_SUCCESS":
      setCurrentUser(action.data);
      console.log('state before user: ', state);
      return Object.assign({}, state, { user: action.data }, {loading: false});

    case types.SPOTIFY_ME_FAILURE:
      console.log(action.error.status);
      return state;

    case types.REMOVE_CURRENT_USER:
      return Object.assign({}, initialState);

    case types.SPOTIFY_REFRESH_TOKEN_SUCCESS:
      console.log(action);
      return state;
    
    case types.SPOTIFY_USER_LOGGED_IN:
      console.log('logged in');
      return action.status;

    case types.SPOTIFY_USER_LOGGED_OUT:
      console.log('logged out');
      return action.status;
    
    default:
      return state;
  }
};

export default currentUser;



// WEBPACK FOOTER //
// ./src/reducers/spotifyUser.js